<div class="page-content-container">
  <h1 class="page-header">Logy</h1>
  <mat-accordion class="example-headers-align">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> Přidat nový záznam </mat-panel-title>
      </mat-expansion-panel-header>
      <form (ngSubmit)="addNewLog()" [formGroup]="logForm">
        <section>
          <mat-button-toggle-group formControlName="logOption">
            <mat-button-toggle
              *ngFor="let option of logOptions"
              [value]="option.value"
              (click)="clearForId()"
              >{{ option.label }}</mat-button-toggle
            >
          </mat-button-toggle-group>
        </section>

        <div class="log-desc-container" [ngSwitch]="logForm.value.logOption">
          <div class="option-description" *ngFor="let option of logOptions">
            <span *ngSwitchCase="option.value">{{ option.description }}</span>
          </div>
        </div>
        <div class="input-containers">
          <mat-form-field appearance="fill" class="input-filed">
            <mat-label>Svědek</mat-label>
            <mat-select formControlName="witnessId">
              <mat-option
                *ngFor="let user of userOptions | async"
                [value]="user.userId"
                >{{ user.name }}</mat-option
              >
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill" class="input-filed">
            <mat-label>Čas v minutách</mat-label>
            <input matInput type="number" formControlName="time" />
          </mat-form-field>

          <mat-form-field
            appearance="fill"
            class="input-filed"
            *ngIf="logForm.value.logOption !== optionType.Me"
          >
            <mat-label>Zadavatel/Dárce</mat-label>
            <mat-select formControlName="fromId">
              <mat-option
                *ngFor="let user of userOptions | async"
                [value]="user.userId"
                >{{ user.name }}</mat-option
              >
            </mat-select>
          </mat-form-field>

          <mat-form-field
            appearance="fill"
            class="input-filed"
            *ngIf="logForm.value.logOption !== optionType.MyTeam
                   && logForm.value.logOption !== optionType.Me"
          >
            <mat-label>Kdo dostane čas</mat-label>
            <mat-select formControlName="forId">
              <mat-option
                *ngFor="let user of userOptions | async"
                [value]="user.userId"
                >{{ user.name }}</mat-option
              >
            </mat-select>
          </mat-form-field>

          <mat-form-field
            appearance="fill"
            class="input-filed"
            *ngIf="logForm.value.logOption === optionType.MyTeam"
          >
            <mat-label>Týmy</mat-label>
            <mat-select formControlName="forId">
              <mat-option
                *ngFor="let team of teamOptions | async"
                [value]="team.teamMembers"
                (click)="setTeam(team.teamName)"
                >{{ team.teamName }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>

        <mat-form-field appearance="fill" class="description-container">
          <mat-label>Popis</mat-label>
          <textarea matInput formControlName="description"></textarea>
        </mat-form-field>

        <mat-action-row>
          <button
            type="submit"
            [disabled]="logForm.invalid"
            mat-raised-button
            color="primary"
          >
            Přidat
          </button>
        </mat-action-row>
      </form>
    </mat-expansion-panel>
  </mat-accordion>

  <div class="log-table-container mat-elevation-z8">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="forName">
        <th mat-header-cell *matHeaderCellDef>Příjemce</th>
        <td mat-cell *matCellDef="let element">{{ element.forName }}</td>
      </ng-container>

      <ng-container matColumnDef="fromName">
        <th mat-header-cell *matHeaderCellDef>Zadavatel/Dárce</th>
        <td mat-cell *matCellDef="let element">{{ element.fromName }}</td>
      </ng-container>

      <ng-container matColumnDef="witnessName">
        <th mat-header-cell *matHeaderCellDef>Svědek</th>
        <td mat-cell *matCellDef="let element">{{ element.witnessName }}</td>
      </ng-container>

      <ng-container matColumnDef="time">
        <th mat-header-cell *matHeaderCellDef>Čas</th>
        <td mat-cell *matCellDef="let element">{{ element.time }}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Popis</th>
        <td class="long-text" mat-cell *matCellDef="let element">
          {{ element.description }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator
      [pageSizeOptions]="[5, 10, 20]"
      aria-label="Select page of periodic elements"
    >
    </mat-paginator>
  </div>
</div>
